module.exports = __webpack_public_path__ + "img/UTKODA-1.a222a30d.jpg";